/* TO ADD ICONS PLEASE FOLLOW THE COMMENTS ON THIS DFILE */
import { head, tail, T, F } from 'ramda'; // IMPORT YOUR ICON

import lock from '../../assets/icons/lock.svg'; // FOR EACH ICON YOU MUST IMPORT IT'S THEME VARIANTS
// IMPORT NAMES MUST FOLLOW THIS CAMEL CASE CRITERIA: iconNameTheme
// DOWN ARROW

import downArrowBase from "../../assets/icons/chevron-down-base.svg";
import downArrowIemas from "../../assets/icons/chevron-down-iemas.svg";
import downArrowOoba from "../../assets/icons/chevron-down-ooba.svg";
import downArrowOldmutual from "../../assets/icons/chevron-down-om.svg";
import downArrowAbsa from "../../assets/icons/chevron-down-absa.svg";
import downArrowRml from "../../assets/icons/chevron-down-rml.svg"; // CONTROLS ALT

import controlsAltBase from "../../assets/icons/controls-alt-base.svg";
import controlsAltIemas from "../../assets/icons/controls-alt-iemas.svg";
import controlsAltOoba from "../../assets/icons/controls-alt-ooba.svg";
import controlsAltOldmutual from "../../assets/icons/controls-alt-om.svg";
import controlsAltAbsa from "../../assets/icons/controls-alt-absa.svg";
import controlsAltRml from "../../assets/icons/controls-alt-rml.svg"; // YOU CAN IMPORT A SINGLE ICON IF YOU ARE GOING TO USE THE SAME SVG FOR ALLL THEMES
// FACEBOOK

import facebook from '../../assets/facebook.svg'; // WHATSAPP

import whatsapp from '../../assets/whatsapp.svg'; // TWITTER

import twitter from '../../assets/twitter.svg'; // GOOGLE

import google from '../../assets/google.svg'; //MESSENGER

import messenger from '../../assets/messenger.svg'; // THEN LIST YOUR ICONS HERE

export var ICONS = {
  lock: lock,
  messenger: messenger,
  facebook: facebook,
  whatsapp: whatsapp,
  twitter: twitter,
  google: google,
  downArrowBase: downArrowBase,
  downArrowIemas: downArrowIemas,
  downArrowOldmutual: downArrowOldmutual,
  downArrowOoba: downArrowOoba,
  downArrowAbsa: downArrowAbsa,
  downArrowRml: downArrowRml,
  controlsAltBase: controlsAltBase,
  controlsAltIemas: controlsAltIemas,
  controlsAltOldmutual: controlsAltOldmutual,
  controlsAltOoba: controlsAltOoba,
  controlsAltAbsa: controlsAltAbsa,
  controlsAltRml: controlsAltRml
};

var createVariatName = function createVariatName(iconName, themeName) {
  return '' + iconName + head(themeName.toUpperCase()) + tail(themeName);
};

export var createIconThemeVariantsMap = function createIconThemeVariantsMap(iconName, useSameIconForAllVariants) {
  var variants = {};
  var themeNames = ["base", "iemas", "ooba", "oldmutual", "absa", "rml"];

  if (useSameIconForAllVariants === false) {
    themeNames.map(function (themeName) {
      var variantName = createVariatName(iconName, themeName);
      variants[themeName] = ICONS[variantName];
    });
  } else {
    themeNames.map(function (themeName) {
      variants[themeName] = ICONS[iconName];
    });
  }

  return variants;
};
/*
   THEN CONFIGURE THE ICON FACTORY TO EITHER USE SAME ICON FOR ALL THEMES OR USE THE ICON VARIANT SVGS YOU IMPORTED
   THE createIconThemeVariantsMap FUNCTION USED BELOW WILL AUTOMATICALLY GENERATE A MAP WITH THE ICON'S THEME VARIANTS
   E.G {
            ooba: '/path/to/ooba-icon.svg'
            iemas: '/path/to/iemas-icon.svg'
            simply: '/path/to/simply-icon.svg'
       }
*/

var USE_SAME_ICON_FOR_ALL_THEMES = T();
var USE_ICONS_WITH_THEME_COLOURS = F();
export var iconVariants = {
  lock: createIconThemeVariantsMap('lock', USE_SAME_ICON_FOR_ALL_THEMES),
  facebook: createIconThemeVariantsMap('facebook', USE_SAME_ICON_FOR_ALL_THEMES),
  twitter: createIconThemeVariantsMap('twitter', USE_SAME_ICON_FOR_ALL_THEMES),
  whatsapp: createIconThemeVariantsMap('whatsapp', USE_SAME_ICON_FOR_ALL_THEMES),
  messenger: createIconThemeVariantsMap('messenger', USE_SAME_ICON_FOR_ALL_THEMES),
  google: createIconThemeVariantsMap('google', USE_SAME_ICON_FOR_ALL_THEMES),
  downArrow: createIconThemeVariantsMap('downArrow', USE_ICONS_WITH_THEME_COLOURS),
  controlsAlt: createIconThemeVariantsMap('controlsAlt', USE_ICONS_WITH_THEME_COLOURS)
};